import { SamplingDecision } from '@opentelemetry/sdk-trace-web';
export function getSamplingDecision(sessionMeta = {}) {
    var _a;
    const isSessionSampled = ((_a = sessionMeta.attributes) === null || _a === void 0 ? void 0 : _a['isSampled']) === 'true';
    const samplingDecision = isSessionSampled ? SamplingDecision.RECORD_AND_SAMPLED : SamplingDecision.NOT_RECORD;
    return samplingDecision;
}
//# sourceMappingURL=sampler.js.map